<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">

      <div class="admPageTitleSec">
        <p class="admPageTitle"> <i class="material-icons cusIconSize">&#xE7FD;</i>
          <span>Manage Regional Administrators</span>
        </p>
      </div>

      <md-card>
        <md-card-header>
          <div class="admPageHeadingSec">
            <md-card-title>
              <div class="admPageHeading">
                <p><span>Search Regional Administrators</span></p>
              </div>
            </md-card-title>
          </div>
        </md-card-header>
        <md-card-content>

          <form class="example-form" [formGroup]="form">

            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="Region" mdInput formControlName="searchRegionControl" [mdAutocomplete]="region" [showDropDown]="{model: 'region', scope : this }">
                  <md-autocomplete #region="mdAutocomplete" [displayWith]="_utility.displayFn">
                    <md-option *ngFor="let option of (regionFilteredOptions | async)" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
              </div>
            </div>
            <div class="col s12 m4 l4">
              <md-form-field class="example-full-width">
                <input type="text" placeholder="Enter First Name or Last Name" mdInput formControlName="searchNameControl" [mdAutocomplete]="searchName">
                <md-autocomplete #searchName="mdAutocomplete">
                  <md-option *ngFor="let option of nameFilteredOptions | async" [value]="option.showStr">
                    {{ option.showStr }}
                  </md-option>
                </md-autocomplete>
              </md-form-field>
            </div>
          </form>


          <div class="col s12 m12 l12">
            <div class="button-row">
              <button [disabled]="isSearchDisable"
                md-raised-button class="glbAdminBtnCls1" (click)="onSearchClick()"><i class="material-icons">&#xE8B6;</i>Search</button>
              <button md-raised-button class="glbAdminBtnCls1 bigBtn" [routerLink]="['/AdmManageRegionalAdmin', 0]" (click)="_appGlobal.routeWithID = true"><i class="material-icons">&#xE145;</i> Add Regional Administrator </button>
            </div>
          </div>


        </md-card-content>
      </md-card>

      <!-- grid code -->
      <div class="cusPaginationContainer example-container mat-elevation-z8" *ngIf="adminDetailPaginationInfo && adminDetailPaginationInfo.totalRecords == 0">
        <p class="nodataFound"> No Results Found</p>
      </div>
      <div class="cusPaginationContainer example-container mat-elevation-z8" [ngClass]="{'hide-grid':adminDetailPaginationInfo && adminDetailPaginationInfo.totalRecords == 0 }">
        <md-table #table [dataSource]="dataSource" mdSort>

          <md-header-row *mdHeaderRowDef="displayedColumns"></md-header-row>
          <md-row *mdRowDef="let row; columns: displayedColumns;"></md-row>

          <!--- Note that these columns can be defined in any order. The actual rendered columns are set as a property on the row definition" -->
          <!-- First Name Column -->
          <ng-container mdColumnDef="firstName">
            <md-header-cell *mdHeaderCellDef md-sort-header>FIRST NAME</md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.firstName}} </md-cell>
          </ng-container>

          <!-- Last name Column -->
          <ng-container mdColumnDef="lastName">
            <md-header-cell *mdHeaderCellDef md-sort-header> LAST NAME </md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.lastName}} </md-cell>
          </ng-container>

          <!-- Email Column -->
          <ng-container mdColumnDef="email">
            <md-header-cell *mdHeaderCellDef md-sort-header> EMAIL </md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.email}} </md-cell>
          </ng-container>

          <!-- Region Column -->
          <ng-container mdColumnDef="regionName">
            <md-header-cell *mdHeaderCellDef md-sort-header>REGION</md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.regionName}} </md-cell>
          </ng-container>

          <!-- Number Column -->
          <ng-container mdColumnDef="contactNo">
            <md-header-cell *mdHeaderCellDef md-sort-header> CONTACT NUMBER </md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.contactNo}} </md-cell>
          </ng-container>

          <!-- Satus Column -->
          <ng-container mdColumnDef="status">
            <md-header-cell *mdHeaderCellDef md-sort-header> STATUS </md-header-cell>
            <md-cell *mdCellDef="let element">
              <span [ngClass]="getStatusCls(element.status)"></span> {{element.status == 1?'Active':'Retired'}} </md-cell>
          </ng-container>

          <!-- Action Column -->
          <ng-container mdColumnDef="Action">
            <md-header-cell *mdHeaderCellDef>ACTIONS</md-header-cell>
            <md-cell *mdCellDef="let element"> <a [routerLink]="['/AdmManageRegionalAdmin', element.id]" (click)="_appGlobal.routeWithID = true">Manage</a> </md-cell>
          </ng-container>
        </md-table>
        <md-paginator #paginator [length]="adminDetailPaginationInfo.totalRecords" [pageIndex]="0" [pageSize]="dataSource.initialPageSize" [pageSizeOptions]="dataSource.pageSizeOptions"></md-paginator>
      </div>

      <!-- grid code end -->

    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-regional-admin/adm-manage-regional-admin.component.html